import { __assign } from '../../node_modules/tslib/tslib.es6.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import classNames from 'classnames';

// same as RowH1H4, but smaller
var RowH2Lead = function (_a) {
    var heading = _a.heading, children = _a.children, _b = _a.mb, mb = _b === void 0 ? '10' : _b;
    return (jsx("div", __assign({ className: "row" }, { children: jsxs("div", __assign({ className: "col-md-8 mx-auto text-center" }, { children: [jsx("h2", __assign({ className: classNames('lh-1-5', children ? 'mb-4' : "mb-".concat(mb)) }, { children: heading })), children && jsx("p", __assign({ className: "lead lh-1-75 fw-light mb-9" }, { children: children }))] })) })));
};

export { RowH2Lead };
